import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { CianMortgageBanner } from '../../../components/NewbuildingMortgageSection/components/CianMortgageBanner';
import { useApplicationContext } from '../../ApplicationContext';
import { formatBannerPayment, getCianMortgageBannerUrl } from '../helpers';
import { trackMortgageBannerClick, trackMortgageBannerShow } from '../tracking';

export interface ICianMortgageBannerContainerProps {
  monthlyPayment: number;
}

export const CianMortgageBannerContainer: React.FC<ICianMortgageBannerContainerProps> = ({ monthlyPayment }) => {
  const { config } = useApplicationContext();
  const bannerUrl = getCianMortgageBannerUrl(config);

  return (
    <ActionAfterViewObserver callback={trackMortgageBannerShow} triggerOnce>
      <CianMortgageBanner
        onClick={trackMortgageBannerClick}
        monthlyPayment={formatBannerPayment(monthlyPayment)}
        url={bannerUrl}
      />
    </ActionAfterViewObserver>
  );
};
